import { ajaxPromise } from './request_helpers';
import { StringConstantsMixin } from '../../application/javascripts/react_components/mixins/shared/string_constants_mixin';

const trackSearchResultClick = (result, position, queryID) => {
  const currentTime = new Date();
  const params = {
    queryID,
    objectID: result.objectID,
    position,
    timestamp: +currentTime
  };

  return ajaxPromise({
    type: 'POST',
    url: 'https://insights.algolia.io/1/searches/click',
    data: JSON.stringify(params),
    dataType: 'json',
    headers: {
      'X-Algolia-Application-Id': StringConstantsMixin.constants.ALGOLIA.ACCOUNT,
      'X-Algolia-API-Key': StringConstantsMixin.constants.ALGOLIA.API_KEY,
      'Content-Type': 'application/json'
    },
    resReducer: () => {}
  });
};

export { trackSearchResultClick };